module.exports = __webpack_public_path__ + "img/legalServices-14.23ea7ae7.png";